import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { PlayCircle, ArrowRight } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";

const sb = supabase as any;

export const ResumeQuizCard = () => {
  const { user } = useAuth();

  const { data: session } = useQuery({
    queryKey: ["resume-quiz-session", user?.id],
    enabled: !!user,
    queryFn: async () => {
      const { data, error } = await sb
        .from("quiz_sessions")
        .select("id, mcq_ids, current_index, session_mode, created_at")
        .eq("user_id", user!.id)
        .eq("status", "in_progress")
        .order("created_at", { ascending: false })
        .limit(1)
        .maybeSingle();
      if (error) return null;
      return data;
    },
  });

  if (!session || !session.mcq_ids?.length) return null;

  const total = session.mcq_ids.length;
  const current = (session.current_index ?? 0) + 1;
  const progress = Math.round(((session.current_index ?? 0) / total) * 100);

  return (
    <Card className="medical-card border-primary/30 bg-primary/5">
      <CardContent className="p-4 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 min-w-0">
          <div className="feature-icon bg-primary/10 text-primary shrink-0">
            <PlayCircle className="h-5 w-5" />
          </div>
          <div className="min-w-0">
            <div className="font-semibold text-foreground flex items-center gap-2 flex-wrap">
              Resume your quiz
              <Badge variant="outline" className="capitalize">{session.session_mode}</Badge>
            </div>
            <div className="text-sm text-muted-foreground">
              Question {current} of {total} · {progress}% complete
            </div>
          </div>
        </div>
        <Button size="sm" className="bg-gradient-medical shrink-0" asChild>
          <Link to={`/practice?resume=${session.id}`}>
            Resume <ArrowRight className="ml-2 h-4 w-4" />
          </Link>
        </Button>
      </CardContent>
    </Card>
  );
};
